module.exports = __webpack_public_path__ + "media/images/home/icon-2-1ce8271258adc5a7f77f1f09232c53e0.png";